import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
	selector: 'app-clear-order-modal',
	templateUrl: './clear-order-modal.component.html',
	standalone: false,
})
export class ClearOrderModalComponent {
	constructor(private dialogRef: MatDialogRef<ClearOrderModalComponent>) {}

	close() {
		this.dialogRef.close();
	}

	clear() {
		this.dialogRef.close(true);
	}
}
